
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import VoterSearch from './pages/VoterSearch';
import VoterDetail from './pages/VoterDetail';
import BoothStats from './pages/BoothStats';
import BoothVoters from './pages/BoothVoters';
import EnrollVoter from './pages/EnrollVoter';
import Logs from './pages/Logs';
import Accounts from './pages/Accounts';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import DataFetches from './pages/DataFetches';
import Printer from './pages/Printer';
import Splash from './pages/Splash';
import EnumeratorStats from './pages/EnumeratorStats';

import OfflineBanner from './components/OfflineBanner';

// Scroll to top on every page change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

function PrivateRoute({ children, adminOnly }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="loader"><div className="spinner"/><p>Loading...</p></div>;
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && !isAdmin) return <Navigate to="/" />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login"          element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/"               element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/search"         element={<PrivateRoute><VoterSearch /></PrivateRoute>} />
      <Route path="/voter/:id"      element={<PrivateRoute><VoterDetail /></PrivateRoute>} />
      <Route path="/booths"         element={<PrivateRoute><BoothStats /></PrivateRoute>} />
      <Route path="/booths/:boothNumber" element={<PrivateRoute><BoothVoters /></PrivateRoute>} />
      <Route path="/enroll"         element={<PrivateRoute><EnrollVoter /></PrivateRoute>} />
      <Route path="/logs"           element={<PrivateRoute><Logs /></PrivateRoute>} />
      <Route path="/accounts"       element={<PrivateRoute adminOnly><Accounts /></PrivateRoute>} />
      <Route path="/settings"       element={<PrivateRoute><Settings /></PrivateRoute>} />
      <Route path="/analytics"      element={<PrivateRoute><Analytics /></PrivateRoute>} />
      <Route path="/data-fetches"   element={<PrivateRoute><DataFetches /></PrivateRoute>} />
      <Route path="/printer"           element={<PrivateRoute><Printer /></PrivateRoute>} />
      <Route path="/enumerator-stats"  element={<PrivateRoute adminOnly><EnumeratorStats /></PrivateRoute>} />
      <Route path="*"               element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  const [showSplash, setShowSplash] = React.useState(true);

  return (
    <AuthProvider>
      {showSplash && <Splash onDone={() => setShowSplash(false)} />}
      <BrowserRouter>
        <ScrollToTop />
        <OfflineBanner />
        <Toaster position="top-center" toastOptions={{ style: { fontFamily: "'Outfit', sans-serif", fontSize: '0.875rem', borderRadius: '12px' } }} />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}